module.exports = (__webpack_require__(77))(0);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/react/cjs/react.production.min.js from dll-reference vendor
// module id = 308
// module chunks = 0